import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance30 = () => {
  return <IndividualTable matchType={"4"} gender="F" event="30" subTitle="Zamby" data={sampleData2} topRankCount="2" winners={["318", "330"]} />;
};
export default Distance30;
